// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".q7T--Backdrop--Backdrop{}.bMd--Backdrop--fixed{position:fixed}.rxG--Backdrop--background,.bMd--Backdrop--fixed{left:0;top:0;width:100%;height:100%}.N7y--Backdrop--variant_popover .rxG--Backdrop--background{background:none}.Q3D--Backdrop--variant_modal .rxG--Backdrop--background{opacity:0.5;background:var(--uikit-color-dimGrey)}.KUv--Backdrop--variant_bottomPanel .rxG--Backdrop--background{position:fixed;top:inherit!important;opacity:0.8;background:var(--uikit-color-black)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"themeBase": "Backdrop",
	"Backdrop": "q7T--Backdrop--Backdrop",
	"fixed": "bMd--Backdrop--fixed",
	"background": "rxG--Backdrop--background",
	"variant_popover": "N7y--Backdrop--variant_popover",
	"variant_modal": "Q3D--Backdrop--variant_modal",
	"variant_bottomPanel": "KUv--Backdrop--variant_bottomPanel"
};
module.exports = ___CSS_LOADER_EXPORT___;
